import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 6,
    paddingLeft: 16,
    paddingVertical: 10,
    marginVertical: 30,
    marginHorizontal: 15,
  },
  text: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  indicatorContainer: {
    flexDirection: 'row',
    marginLeft: 16,
    marginRight: 12,
  },
  indicatorText: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  wrapper: {
    position: 'absolute',
    bottom: -100,
    left: 0,
    right: 0,
  },
  padding: {
    height: 85,
  },
});
